export const adminDashboardPath = "/admin-dashboard";
export const chatPath = "/chat/:chatId";

export const getChatPath = (chatId: string) => `/chat/${chatId}`;
